module.exports = __webpack_public_path__ + "assets/160cbc601ae8e63c6da7e1dc6aaf6c06.mp3";